module.exports = __webpack_public_path__ + "static/media/slide2.06d0363b.png";